// extracted by mini-css-extract-plugin
export default {"container":"qK7W_W","viewer":"medlZo","truncated":"_iiwXJ","expandTransition":"fqpxmM","shrinkTransition":"GN5b3T","showMore":"_IHe96"};